import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface UseLanguageSwitch {
  enabled: boolean;
  language: "en" | "zh";
  defaultLanguage?: string;
}

export const useLanguageSwitch = ({ enabled, language, defaultLanguage = "en" }: UseLanguageSwitch) => {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (enabled) {
      i18n.changeLanguage(language);
    } else {
      i18n.changeLanguage(defaultLanguage);
    }
  }, [enabled, language, defaultLanguage, i18n]);
};
